let trackerObject = null;

function tracker () {
    if (trackerObject === null) {
        if (window && window.Matomo &&
            typeof (window.Matomo.getAsyncTracker) === "function") {
            trackerObject = Matomo.getAsyncTracker();
        }
        else {
            if (console) console.log(
                "Matomo tracker not found... using a fake object.");
            trackerObject = new FakeTrackerObject();
        }
    }
    return trackerObject;
}

class FakeTrackerObject {
    trackPageView () {
    }

    trackEvent () {
    }

    disablePerformanceTracking () {
    }

    enableCrossDomainLinking () {
    }

    setCrossDomainLinkingTimeout () {
    }

    getCrossDomainLinkingUrlParameter () {
    }
}

if (window && !(window.bridge && window.bridge.isElectronApp)) {
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
        var u = "//matomo.cabricloud.com/";
        _paq.push(["setTrackerUrl", u + "matomo.php"]);
        _paq.push(["setSiteId", "6"]);
        var d = document, g = d.createElement("script"),
            s = d.getElementsByTagName("script")[0];
        g.type = "text/javascript";
        g.async = true;
        g.src = u + "matomo.js";
        s.parentNode.insertBefore(g, s);
    })();
}

export {tracker};